<template>
  <el-dialog
    :title="detailList.userName + '  三年考核评选结果'"
    :close-on-click-modal="false"
    :visible="detailData.state"
    width="480px"
    :modal="false"
    @close="closeModal()"
  >
  <div class="list" v-for="(item,index) in detailList.list" :key="index + 'q'">
    <div class="item card-shadow">
        <span>{{item.yearCheckTime}}年</span>
        -------------
        <span>{{item.yearCheckResultDesc}}</span>
    </div>
  </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
    props:["detailData","detailList"],
    data(){
        return{

        }
    },
    methods:{
        closeModal(){
          this.detailData.state = false
        }
    }
};
</script>

<style lang="less" scoped>
.list{
  padding-bottom: 15px;
  .item{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
</style>